export default __webpack_public_path__ + "0e8c60e0a94756e6de401449683792fb.png";